// extracted by css-extract-rspack-plugin
export default {"marker":"SI5fFWUAlpcgZbZY"};